export const SET_LANG_DATA = '[LANG] SET_LANG_DATA';